// necessary set
import { makeObservable, observable } from 'mobx'

// import ReactDOMServer from 'react-dom/server'

/**
 *
 * @author cardo
 * @description
 * sto-admin-front UtilsStore
 */
export class UtilsStore {
  error: string = ''
  startDate: Date = new Date(new Date().setTime(new Date().getTime() - 24 * 60 * 60 * 1000))
  endDate: Date = new Date()
  outSideClose: boolean = false
  alert: { title: string; cont?: any; action?: (e: any) => void }[] = []

  constructor() {
    makeObservable(this, {
      error: observable,
      startDate: observable,
      endDate: observable,
      outSideClose: observable,
      alert: observable,
    })
  }

  setErrorText(errorText: string): void {
    this.error = errorText
  }
}
